import type React from "react";

export function isIE11() {
  return window.navigator.userAgent.indexOf("Trident/") >= 0;
}

export function isMac() {
  return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
}

export function isFirefox() {
  return window.navigator.userAgent.indexOf("Firefox") >= 0;
}

export function isSafari() {
  // https://stackoverflow.com/a/23522755/616974
  return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
}

export function getChromeVersion() {
  // https://stackoverflow.com/a/4900484/616974
  const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : false;
}

export function isAndroid() {
  return window.navigator.userAgent.indexOf("Android") >= 0;
}

export function isWithMetaKey(
  e: React.MouseEvent<any, any> | React.KeyboardEvent<any> | MouseEvent | KeyboardEvent
) {
  return isMac() ? e.metaKey : e.ctrlKey;
}

export const supportsLightDark = () => {
  if (typeof CSS !== "undefined" && CSS.supports) {
    try {
      return CSS.supports("color", "light-dark(black, white)");
    } catch {
      // Fall through to method 2
    }
  }
  return false;
};
